import {FC} from 'react';

import CreateOrderForm from './components/createOrderForm';
import {CreateOrderProvider} from './providers/createOrderProvider';

/**
 * Create positions page
 * @returns {JSX.Element}
 */
const CreateOrderPage: FC = () => {
  return (
    <CreateOrderProvider>
      <CreateOrderForm />
    </CreateOrderProvider>
  );
};

export default CreateOrderPage;
